/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Nutrition_FixInputs */

const en_nutrition_fix = /** @type {(inputs: Nutrition_FixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fix ${i?.count} ingredients`)
};

const de_nutrition_fix = /** @type {(inputs: Nutrition_FixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Zutaten korrigieren`)
};

/**
* | output |
* | --- |
* | "Fix {count} ingredients" |
*
* @param {Nutrition_FixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrition_fix = /** @type {((inputs: Nutrition_FixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrition_FixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrition_fix(inputs)
	return en_nutrition_fix(inputs)
});